import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c2bf724"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "aside" }
const _hoisted_2 = { class: "menu" }
const _hoisted_3 = ["onClick"]

import { storeToRefs } from 'pinia';
import { useHome, useTab, useMedia } from '@/store';
import { Tab } from '@/types/enums';
import NavbarBtn from './NavbarBtn.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const { tabs } = storeToRefs(useHome());
const { currentTab, error } = storeToRefs(useTab());
const { getTab, updateCurrentTab } = useTab();
const { closeMedia } = useMedia();
const switchTab = async (id: number, name: string) => {
  if (id === currentTab.value) return;
  /* eslint-disable @typescript-eslint/camelcase */
  closeMedia();
  if (id === Tab.Home) {
    updateCurrentTab(id);
    window.gtag('event', 'click_tab', {
      tab_name: name,
    });
  } else {
    await getTab(id);
    if (!error.value) {
      updateCurrentTab(id);
      window.gtag('event', 'click_tab', {
        tab_name: name,
      });
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createVNode(NavbarBtn, {
      class: "home",
      id: 0,
      topic: '',
      subtopic: '',
      img: '',
      onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTab(_unref(Tab).Home, 'home')))
    }),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(['item', { 'item--active': tab.id === _unref(currentTab) }]),
          onClick: ($event: any) => (switchTab(tab.id, tab.topic))
        }, [
          _createVNode(NavbarBtn, {
            id: tab.id,
            topic: tab.topic,
            subtopic: tab.subtopic,
            img: tab.img
          }, null, 8, ["id", "topic", "subtopic", "img"])
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})